import React from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { styled } from '@mui/material/styles';
import { InputLabel } from '@mui/material';
import { COLORS } from '../../../utils/Application_Constants';

const StyledDatePicker = styled(DatePicker)(() => ({
    '& .MuiPickersInputBase-root': {
        fontWeight: '400',
        borderRadius: 4,
        border: `1px solid ${COLORS.LT_MIDNIGHT5}`,
        fontSize: '14px',
        paddingLeft: 8,
        paddingTop: '6px',
        paddingBottom: '6px',
        marginTop: '0',
    },
    '& div.Mui-focused': {
        border: `1px solid ${COLORS.LT_JOURNEY}`,
    },
    '& .MuiIconButton-root': {
        color: COLORS.LT_JOURNEY,
    },
    '& .MuiInputAdornment-root': {
        color: COLORS.LT_JOURNEY,
        paddingRight: 8,
    },
    '&.Mui-disabled .MuiIconButton-root': {
        background: COLORS.LT_MIDNIGHTBG2,
        color: COLORS.LT_MIDNIGHT33,
        borderRadius: 0,
    },
    '&.Mui-disabled .MuiPickersInputBase-root': {
        background: COLORS.LT_MIDNIGHTBG2,
        color: COLORS.LT_MIDNIGHT33,
    },
}));

const ExpenseDatePicker = (props) => {
    const { parentTextFieldProps, required, label, parentSx } = props;
    const [focused, setFocused] = React.useState(false);

    const validateInput = (inputValue, inputChar, caretPositionProp) => {
        const parts = inputValue.split('/');
        let [month, day, year] = parts;
        let caretPosition = caretPositionProp;
        const isSlash = caretPosition === 2 || caretPosition === 5;
        caretPosition = isSlash ? caretPosition + 1 : caretPosition;
        const isMonth = caretPosition < 2;
        const isDay = caretPosition >= 2 && caretPosition <= 4;
        const isYear = caretPosition > 4;
        let isValid = true;

        if (isMonth) {
            month = inputValue.slice(0, caretPosition) + inputChar;
            const { length } = month;
            const regex = length === 1 ? /^[01]$/ : /^(0?[1-9]|1[0-2])$/;
            isValid = regex.test(month);
        }

        if (isDay) {
            day = inputValue.slice(3, caretPosition) + inputChar;
            const { length } = day;
            const regex = length === 1 ? /^[0-3]$/ : /^(0[1-9]|[12]\d|3[01])$/;
            isValid = regex.test(day);
        }

        if (isYear) {
            year = inputValue.slice(6, caretPosition) + inputChar;
            const { length } = year;
            let regex;
            switch (length) {
                case 1:
                    regex = /^[1-3]$/;
                    break;
                case 2:
                    regex = /^(1[9-9]|2[0-9]|30)$/;
                    break;
                case 3:
                    regex = /^(19\d{1,2}|2\d{2}|300)$/;
                    break;
                case 4:
                    regex = /^(19\d{2}|2\d{3}|3000)$/;
                    break;
                default:
                    isValid = false;
            }

            if (regex) {
                isValid = regex.test(year);
            }
        }

        return isValid;
    };

    const handleKeyPress = (event) => {
        const inputValue = event.target.value;
        const inputChar = String.fromCharCode(event.keyCode || event.which);
        const caretPosition = event.target.selectionStart;

        const isValidInput = validateInput(inputValue, inputChar, caretPosition);

        if (!isValidInput) {
            event.preventDefault();
        }
    };
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <InputLabel
                shrink
                sx={{
                    '& .MuiInputLabel-asterisk': {
                        color: COLORS.LT_PEPPER, // Change asterisk color to red
                    },
                }}
                required={required}
                focused={focused}
                error={parentTextFieldProps?.error}
            >
                {label}
            </InputLabel>
            <StyledDatePicker
                onKeyPress={handleKeyPress}
                inputFormat="MM/dd/yyyy"
                sx={() => ({
                    '& .MuiInputLabel-shrink': {
                        transform: 'translate(0, 1.5px) scale(0.75) !important',
                    },
                })}
                slotProps={{
                    textField: {
                        ...parentTextFieldProps, // Keep Parent Props
                        sx: {
                            ...parentSx, // Keep Parent Props
                            margin: '0', // Adjust margin as needed
                        },
                        variant: 'standard',
                        disableUnderline: true,
                        onFocus: () => setFocused(true),
                        onBlur: () => setFocused(false),
                        margin: 'none',
                        shrink: true,
                        InputProps: {
                            shrink: true,
                            disableUnderline: true,
                        },
                        SelectProps: {
                            shrink: true,
                            disableUnderline: true,
                        },
                    },
                    openPickerButton: {
                        'aria-label': label || 'Choose date',
                    },
                    popper: {
                        onFocus: () => setFocused(true),
                        onBlur: () => setFocused(false),
                    },
                    disableUnderline: true,
                    shrink: true,
                }}
                {...props}
                label={undefined}
            />
        </LocalizationProvider>
    );
};

export default ExpenseDatePicker;
